import { EnvironmentalVariables } from "enum/EnvironmentalVariables";
import { IColorMap, ILayerInfo } from "types/IForecastMap";
import api from "./api";

export default class ForecastMapService {
  async getForecastMapInfo(
    environmentalVariable: EnvironmentalVariables
  ): Promise<ILayerInfo> {
    const result = await api.get<ILayerInfo>("/v1/forecast-map/info", {
      params: {
        environmentalVariable,
      },
    });

    return result.data;
  }

  async getColormap(
    environmentalVariable: EnvironmentalVariables
  ): Promise<IColorMap> {
    const result = await api.get<IColorMap>("/v1/forecast-map/colormap", {
      params: {
        environmentalVariable,
      },
    });

    return result.data;
  }
}
